import { ModalConfirmation, ModalConfirmationProps } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

interface DeleteBillConfirmationModalProps extends ModalConfirmationProps {
  isDeleting?: boolean
  onOk?: () => void
}

export const DeleteBillConfirmationModal = ({
  id,
  isDeleting,
  onOk,
  ...props
}: DeleteBillConfirmationModalProps): ReactElement => {
  const { t } = useTranslation()

  const handleDeleteModalOkClick = useCallback(() => {
    onOk?.()
  }, [onOk])

  return (
    <ModalConfirmation
      {...props}
      cancelLabel={t('cancel')}
      danger
      id={id}
      message={t('bill.action.delete.message')}
      okLabel={t('delete')}
      okLoading={isDeleting}
      onOk={handleDeleteModalOkClick}
      title={t('bill.action.delete.title')}
    />
  )
}
